import { useMutation, useQueryClient } from '@tanstack/react-query';
import { gqlFetcher, type MutationOptions } from '../fetcher';
import { UpdateIncidentCategory } from '../mutations/updateIncidentCategory.mutation';
import type {
  UpdateIncidentCategoryMutation,
  UpdateIncidentCategoryMutationVariables,
} from '../types';

export const useUpdateIncidentCategoryMutation = (
  options?: MutationOptions<
    UpdateIncidentCategoryMutation,
    UpdateIncidentCategoryMutationVariables
  >,
) => {
  const queryClient = useQueryClient();

  return useMutation(gqlFetcher(UpdateIncidentCategory), {
    ...options,
    onSettled: async (resp, error, variables, ctx) => {
      await options?.onSettled?.(resp, error, variables, ctx);

      queryClient.invalidateQueries({
        predicate: (query) => query.queryKey.includes(['incidentCategories']),
      });
    },
  });
};
